// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"d54855fe","972":"d54855fe"}[chunkId] + ".chunk.css";
};